import { render, staticRenderFns } from "./RelacaoContrato.vue?vue&type=template&id=c1962f62"
import script from "./RelacaoContrato.vue?vue&type=script&lang=js"
export * from "./RelacaoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports